import { render, staticRenderFns } from "./Generate.vue?vue&type=template&id=3b6c9b7c&"
import script from "./Generate.vue?vue&type=script&lang=js&"
export * from "./Generate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports